import { render, staticRenderFns } from "./FormCOSCompliance.vue?vue&type=template&id=7881f2b2&lang=pug"
import script from "./FormCOSCompliance.vue?vue&type=script&lang=ts"
export * from "./FormCOSCompliance.vue?vue&type=script&lang=ts"
import style0 from "./FormCOSCompliance.vue?vue&type=style&index=0&id=7881f2b2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports